import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import Footer from './../Layouts/Footer';
import API from './../Function/APILink'
import Datetime from './../Function/Datetime';
import FontAwesome from 'react-fontawesome'
import { Link } from 'react-router-dom'
import Preload from '../Layouts/Preload';
import SocialShare from '../Layouts/SocialShare';
import GoTop from '../Function/GoTop';
import Header from '../Layouts/Header';
import SidebarDetail from '../Layouts/SidebarDetail';

export class Detail extends Component {

    constructor(props){
        super(props)

        this.componentDidMount = this.componentDidMount.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleResponse = this.handleResponse.bind(this)
        this.handleFeedback = this.handleFeedback.bind(this)
        this.state = {
            title: '',
            description: '',
            content: '',
            onairdate: '',
            view: 0,
            helpful: 0,
            tag: [],
            totalrecord: 0,
            feddbackStatus: '',
            feedbackText: '',
            feedbackName: '',
            feedbackEmail: '',
            feedbackPhone: '',
            idFeedbackHelpful: 0,
            emptyfeedbackText: false,
            emptyfeedbackName: false,
            emptyfeedbackEmail: false,
            emptyfeedbackPhone: false,
            token: 'qwertygf123456',
            preloader: true,
            nextcontent: [],
            url: '',
            idcategory1: '0',
            idcategory2: '0',
            idcategory3: '0',
            category1: '',
            category2: '',
            category3: '',
            lastedit: '',
        }
    }

    handleChange(event) {
        if(""===event.target.value){
            if("feedbackEmail"===event.target.name || "feedbackPhone"===event.target.name){                                
                if( ("feedbackEmail"===event.target.name && ""!==this.state.feedbackPhone) || ("feedbackPhone"===event.target.name && ""!==this.state.feedbackEmail)){
                    this.setState({
                        [event.target.name]: event.target.value,
                        emptyfeedbackEmail: false,
                        emptyfeedbackPhone: false
                    })
                } else {
                    this.setState({
                        [event.target.name]: event.target.value,
                        emptyfeedbackEmail: true,
                        emptyfeedbackPhone: true
                    })
                }
            } else {
                this.setState({
                    [event.target.name]: event.target.value,
                    ["empty"+event.target.name]: true,
                })
            }
        } else {
            if("feedbackEmail"===event.target.name || "feedbackPhone"===event.target.name){
                this.setState({
                    [event.target.name]: event.target.value,
                    emptyfeedbackEmail: false,
                    emptyfeedbackPhone: false
                })
            } else {
                this.setState({
                    [event.target.name]: event.target.value,
                    ["empty"+event.target.name]: false,
                })
            }
        }
    }

    async handleResponse(respon) {
        this.setState({
            feddbackStatus: respon
        })
        if(1===respon){
            await API.get("AddCounterHelpful.php?token="+this.state.token+"&id="+this.state.id)
            .then(response => {
                if(response.data>0) {
                    this.setState(prevstate => ({
                        idFeedbackHelpful: response.data,
                        helpful: +prevstate.helpful+1
                    }))
                }
            })
            .catch(error => {
                this.setState({
                    idFeedbackHelpful: 0
                })
            })
        }
    }

    async handleFeedback(respon) {
        
        const { token, id, feedbackText, feedbackName, feedbackEmail, feedbackPhone, idFeedbackHelpful } = this.state

        if(1===respon){
            if(""===feedbackText){
                this.setState({
                    emptyfeedbackText: true
                })
            } else {
                if(0!==idFeedbackHelpful && ""!==idFeedbackHelpful){
                    await API.post("AddHelpfulFeedback.php", {token: token, id: idFeedbackHelpful, message: feedbackText})
                }

                this.setState({
                    feddbackStatus: 2
                })
            }
        } else if (0===respon) {
            if(""===feedbackText || ""===feedbackName || (""===feedbackEmail && ""===feedbackPhone)){
                if(""===feedbackText){
                    this.setState({
                        emptyfeedbackText: true
                    })
                } 
                if(""===feedbackName){
                    this.setState({
                        emptyfeedbackName: true
                    }) 
                } 
                if(""===feedbackEmail && ""===feedbackPhone){
                    this.setState({
                        emptyfeedbackEmail: true,
                        emptyfeedbackPhone: true
                    }) 
                } 
            } else {
                await API.post("AddCounterNotHelpful.php",{token: token, id: id, message: feedbackText, name: feedbackName, email: feedbackEmail, phone: feedbackPhone})
                
                this.setState({
                    feddbackStatus: 2
                })
            }
        }
    }

    componentWillMount() {
        this.setState({
            url: this.props.match.params.url,
            nexturl: (this.props.match.params.nexturl) ? this.props.match.params.nexturl : []
        })
    }

    async componentDidMount() {

        this.setState({
            preloader: true
        })

        this.setState({
            url: this.props.match.params.url,
            nexturl: (this.props.match.params.nexturl) ? this.props.match.params.nexturl : []
        }, async () => {
            await API.get("GetContentDetail.php?token="+this.state.token+"&url="+this.state.url)
            .then(response => {
                this.setState({
                    id: response.data["RECORD"].ContentID,
                    title: response.data["RECORD"].Title,
                    description: response.data["RECORD"].Description,
                    content: response.data["RECORD"].Content,
                    onairdate: response.data["RECORD"].OnAirDate,
                    view: response.data["RECORD"].View,
                    helpful: response.data["RECORD"].Helpful,
                    idcategory1: response.data["RECORD"].CatID_1,
                    idcategory2: response.data["RECORD"].CatID_2,
                    idcategory3: response.data["RECORD"].CatID_3,
                    category1: response.data["RECORD"].CatName_1,
                    category2: response.data["RECORD"].CatName_2,
                    category3: response.data["RECORD"].CatName_3,
                    lastedit: response.data["RECORD"].LastEdit,
                    preloader: false
                })

                if(response.data["TOTAL_RECORD"]===0){
                    this.props.history.push("/")
                } else {
                    API.get("GetTagDetail.php?token="+this.state.token+"&url="+this.state.url)
                    .then(response => {
                        this.setState({
                            tag: response.data["RECORD"]
                        })
                    })
                    .catch(error => {
                        this.setState({
                            tag: []
                        })
                    })                    
                }
            })
            .catch(error => {
                this.setState({
                    id: '',
                    title: '',
                    description: '',
                    content: '',
                    onairdate: '',
                    view: '',
                    helpful: '',
                    idcategory1: '0',
                    idcategory2: '0',
                    idcategory3: '0',
                    category1: '',
                    category2: '',
                    category3: '',
                    lastedit: '',
                    preloader: false
                })
            })
        })
    }

    render() {
        
        const url = this.props.match.params.url
        const { 
            title, description, content, onairdate, tag, view, helpful, 
            feddbackStatus, feedbackName, feedbackEmail, feedbackPhone, feedbackText,
            emptyfeedbackName, emptyfeedbackEmail, emptyfeedbackPhone, emptyfeedbackText,
            idcategory1, idcategory2, idcategory3, category1, category2, category3, lastedit,
            preloader
        } = this.state
        var rendertag, renderresponse
        
        rendertag = (
            tag.map(tag => {
                return <Link key={tag.TagID} to={`/search?keyword=${tag.Tag}`}>{tag.Tag}</Link>
            })
        )

        if(1===feddbackStatus) {
            renderresponse = (
                <div>
                    Hebat! Ada umpan balik lainnya?<br/>
                    {(true===emptyfeedbackText) ? <><label className="label-required">Pesan wajib diisi!</label><br/></> : ''}
                    <textarea name="feedbackText" onChange={this.handleChange} rows="6" cols="60" maxLength="250" placeholder="Semakin banyak yang Anda sampaikan kepada kami, semakin banyak hal yang dapat kami bantu." required="" value={feedbackText}></textarea><br/>
                    <button onClick={() => this.handleFeedback(1)} className="btn btn-green">Kirim</button>
                </div>
            )
        } else if(0===feddbackStatus){
            renderresponse = (
                <>
                    Bagaimana kami dapat meningkatkannya?<br/>
                    <table width="100%">
                        <tbody>
                            <tr>
                                <td>Nama</td>
                                <td>:</td>
                                <td>
                                    {(true===emptyfeedbackName) ? <><label className="label-required">Nama wajib diisi!</label><br/></> : ''}
                                    <input name="feedbackName" onChange={this.handleChange} size="79" value={feedbackName} placeholder="Nama" />
                                </td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>:</td>
                                <td>
                                    {(true===emptyfeedbackEmail) ? <><label className="label-required">Email/No. HP wajib diisi!</label><br/></> : ''}
                                    <input name="feedbackEmail" onChange={this.handleChange} size="79" value={feedbackEmail} placeholder="Email kantor" />
                                </td>
                            </tr>
                            <tr>
                                <td>No. HP</td>
                                <td>:</td>
                                <td>
                                    {(true===emptyfeedbackPhone) ? <><label className="label-required">No. HP/Email wajib diisi!</label><br/></> : ''}
                                    <input name="feedbackPhone" onChange={this.handleChange} size="79" value={feedbackPhone} placeholder="Nomor yang bisa dihubungi" />
                                </td>
                            </tr>
                            <tr>
                                <td>Pesan</td>
                                <td>:</td>
                                <td>
                                    {(true===emptyfeedbackText) ? <><label className="label-required">Pesan wajib diisi!</label><br/></> : ''}
                                    <textarea name="feedbackText" onChange={this.handleChange} rows="6" cols="60" maxLength="250" placeholder="Semakin banyak yang Anda sampaikan kepada kami, semakin banyak hal yang dapat kami bantu." required="" value={feedbackText}></textarea>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td><button onClick={() => this.handleFeedback(0)} className="btn btn-green">Kirim</button></td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )
        } else if(2===feddbackStatus){
            renderresponse = "Terima kasih atas umpan balik Anda!"
        } else {
            renderresponse = (
                <>
                    Apakah konten ini membantu?
                    <button onClick={() => this.handleResponse(1)} className="btn btn-green">Iya</button>
                    <button onClick={() => this.handleResponse(0)} className="btn btn-red">Belum</button>
                </>
            )
        }

        return (
            <>
                <Preload show={preloader} />
                <GoTop scrollStepInPx="50" delayInMs="30" />
                <Header keyword="" showsortir="false" {...this.props}/>
                <div className="body margin-top-heading">
                    <div className="content-detail">
                        <div className="category">
                            <Link to={`/search?category=${idcategory1}&levelcat=1`}>{ReactHtmlParser(category1)}</Link>
                            {("0"!==idcategory2) ? <> / <Link to={`/search?category=${idcategory1}&category2=${idcategory2}&levelcat=2`}>{ReactHtmlParser(category2)}</Link></> : ''}
                            {("0"!==idcategory3) ? <> / <Link to={`/search?category=${idcategory1}&category2=${idcategory2}&category3=${idcategory3}&levelcat=3`}>{ReactHtmlParser(category3)}</Link></> : ''}
                        </div>
                        <div className="title">{title}</div>
                        <div className="remark">
                            <span><Datetime input={onairdate}/> </span>
                            <span className="gf-green" title={`Jumlah dilihat: ${view}`}><FontAwesome name="eye"/> {view} </span>
                            <span className="gf-orange" title={`Jumlah terbantu: ${helpful}`}><FontAwesome name='star'/> {helpful}</span>
                            
                        </div>
                        <SocialShare shareURL={`http://www.gfsoftindo.com/esupport/detail/${url}`} title={title} hashtagarray={tag} />
                        <hr/>
                        <div className="value">
                            {ReactHtmlParser(description)}
                            <br/>
                            {ReactHtmlParser(content)}
                        </div>
                        <div className="tag">
                            Tag: {rendertag}
                        </div>
                        <hr/>
                        <div className="lastupdate">
                            Terakhir diperbaharui: {(lastedit > onairdate) ? <Datetime input={lastedit}/> : <Datetime input={onairdate}/>}
                        </div>
                        <div className="response">
                            {renderresponse}
                        </div>
                    </div>
                    <SidebarDetail refresh={this.componentDidMount} />
                </div>
                <Footer />
            </>
        )
    }
}

export default Detail
